"use client";

import type { ReactNode } from "react";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { legalDir } from "@/content/legal-policies";
import { useLocale } from "@/lib/i18n/provider";

export function LegalPageShell({ children }: { children: ReactNode }) {
  const { locale } = useLocale();
  return (
    <div dir={legalDir(locale)}>
      <div id="top" />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default LegalPageShell;
